import { render, staticRenderFns } from "./ElectricityStatistics.vue?vue&type=template&id=3364cd87&"
import script from "./ElectricityStatistics.vue?vue&type=script&lang=js&"
export * from "./ElectricityStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ElectricityStatistics.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports